// extracted by mini-css-extract-plugin
export default {"buttonsCell":"PricingResultProductRow_buttonsCell__dXZ1-","productLink":"PricingResultProductRow_productLink__rw-31"};